import React, { useEffect , useRef } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Button from '../Button';
import Icon from '../Icon';
import uniqueId from 'lodash/uniqueId';
import Collapse from 'bootstrap/js/dist/collapse';
export interface VHSAccordionItems {
	/**
	 * @noUI
	 */
	itemId?: string;
	index?: number;
	title?: string;
	expanded?: boolean;
	setHeight?: boolean;
	/**
	 * Item Content
	 * @control richtext
	 */
	content?: string;
}
export interface IVHSAccordionProps extends IBaseElementProps {
	/**
	 * @noUI
	 */
	id?: string;
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Large Titles
	 */
	largeTitles?: boolean;
	/**
	 * Items
	 */
	items?: VHSAccordionItems[];
	/**
	 * Show Label
	 */
	showLabel?: string;
}

/**
 * Accordion
 * @block
 * @icon list-view
 */
const VHSAccordion: React.FC<IVHSAccordionProps> = ({
	heading,
	largeTitles,
	items = [],
	showLabel,
}) => {
	const [showAll, setShowAll] = React.useState([]);

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {

		if (!ref.current) {
			return;
		}

		const initCollapse = () => {
			const collapseTriggerList = [].slice.call(
				ref.current.querySelectorAll('.vhs-accordion'),
			);

			collapseTriggerList.map(function (collapseTriggerEl) {
				return new Collapse(collapseTriggerEl);
			});
		};
		initCollapse();
	}, []);

	const toggleShowAll = (index) => {
		// if index is in showAll, remove it
		if (showAll.indexOf(index) !== -1) {
			setShowAll((prev) => prev.filter((item) => item !== index));
			return;
		}
		setShowAll( (prev) => [...prev, index] );
	}

	const accordionID = uniqueId('vhs-accordion-key');

	if (!items ) {
		return null;
	}

	return (
		<div
			id={accordionID}
			className={cn('vhs-accordion', 'accordion-flush')}
			ref={ref}
		>
			{heading && <h2 className="vhs-accordion__heading">{heading}</h2>}
			{items.length > 0 &&
				<ul className="vhs-accordion__items">
					{items.map((item, index) => {
						if (item?.content && item?.content!='') {
							return (
								<li
									className={cn(
										'vhs-accordion__item',
										item.expanded && 'expanded',
									)}
									key={index}
									>
									<div
										className="vhs-accordion__header"
										id={`${accordionID}-header-${index}`}
									>
										<Button
											className={cn(
												'vhs-accordion__button',
												!item.expanded && 'collapsed',
											)}
											data-bs-toggle="collapse"
											data-bs-target={`#${accordionID}--collapse-${index}`}
											aria-expanded={item.expanded}
											aria-controls={`${accordionID}--collapse-${index}`}

											onClick={(e) => {

												const button = e.target.closest('.vhs-accordion__button');
												const wrapper = e.target.closest('.vhs-accordion__item');
												const items = ref.current?.querySelectorAll(
													'.vhs-accordion__item',
												) as NodeListOf<HTMLInputElement>;

												items && items.forEach((item) => {
													item.classList.remove('expanded');
												});

												if (!wrapper.classList.contains('expanded') && !button.classList.contains('collapsed')) {
													wrapper.classList.add('expanded');
												}

												if (!button.classList.contains('collapsed')) {
													const offset = (screen.width < 992) ? 70 : 103;
													setTimeout(function () {
														const distanceFromTop = window.pageYOffset + e.target.parentNode.getBoundingClientRect().top;
														const distanceFromTop2 = distanceFromTop - offset;
														window.scrollTo(0, distanceFromTop2);
													}, 500);
												}

											}}
										>
											<div
												className={cn(
													'vhs-accordion__title',
													largeTitles && 'vhs-accordion__title--large',
												)}
											>
												{item.title}
											</div>
											<div className="vhs-accordion__icon"></div>
										</Button>
									</div>
									<div
										className={cn(
											'vhs-accordion__collapse',
											'collapse',
											item.expanded ? 'show' : '',
											item.setHeight ? 'set-height' : '',
										)}
										id={`${accordionID}--collapse-${index}`}
										aria-labelledby={`vhs-accordion-header-${index}`}
										data-bs-parent={`#${accordionID}`}
									>
										<div className="vhs-accordion__wrapper">
											<div
												className={cn(
													'vhs-accordion__body',
													largeTitles && 'vhs-accordion__body--large',
												)}
												dangerouslySetInnerHTML={{ __html: item.content }}
											/>
											{item.setHeight && (
												<Button
												className={cn(
													'vhs-accordion__show',
													'table-overlay',
												)}
												onClick={(e) => {
													e.target.parentNode?.parentNode?.classList.toggle(
														'set-height',
													);
													e.target?.classList.toggle(
														'table-overlay',
													);
													toggleShowAll(index);
												}}
											>
												{' '}
												{showAll.indexOf(index) !== -1 ? (
													<>
														Hide
														<Icon name="caret-up" />
													</>
												) : (
													<>
														{showLabel}
														<Icon name="caret-down" />
													</>
												)}
											</Button>
											)}
										</div>
									</div>
								</li>
								)
							}
						}
					)}
			</ul>
			}
		</div>
	);
};

export default VHSAccordion;
